// @flow

import React from "react";
import type { SearchCoursesFormProps } from "../../utils/types";
import LiveSearchInput from "../../common/LiveSearchInput";
import SelectCourses from "../../common/SelectCourses";

const SearchCoursesForm = ({
  courses,
  course_type,
  SearchableText,
  translations,
  onSubmitHandle,
  onUpdateFormValue,
  vocabulary,
}: SearchCoursesFormProps) => {
  const courseTypes = [
    ...new Set(
      courses
        .map((course) => course.course_type)
        .filter((value) => value)
        .sort()
    ),
  ];

  return (
    <div className="course-search-wrapper">
      <form onSubmit={onSubmitHandle}>
        <SelectCourses
          courseTypes={courseTypes}
          onUpdateSelect={(value) => onUpdateFormValue({ course_type: value })}
          course_type={course_type}
          translations={translations}
          vocabulary={vocabulary}
        />
        <LiveSearchInput
          courses={courses}
          course_type={course_type}
          onUpdate={(value) => onUpdateFormValue({ SearchableText: value })}
          SearchableText={SearchableText}
          translations={translations}
          vocabulary={vocabulary}
        />
        <button type="submit" className="btn">
          {translations.search_button_text}
        </button>
      </form>
    </div>
  );
};

export default SearchCoursesForm;
